export const XSMALL = `.5rem`;
export const SMALL = `1rem`;
export const MEDIUM = `2rem`;
export const LARGE = `4rem`;
export const XLARGE = `6rem`;
export const XXLARGE = `8rem`;
export const XXXLARGE = `12rem`;
export const XXXXLARGE = `20rem`;
